const domainName = 'dev.rcscbs.com';

export const environment = {
  production: true,
  domainName: domainName,
  canNavigateToSellThroughReportV2: true,
  stripe_publish_key:
    'pk_test_51Np67ySDpSRWbehenEToriW10F2atJYNOUrVaPV1orBefzY5WPcP3u9TuHcFHfPQmwa4f9OKrYQbWasYtNfHCXvm00JP4WNDQ8',
  stripe_secret_key:
    'sk_test_51Np67ySDpSRWbeheIkQXqa49C2S3IbrdP0XeW4QTOuXAexq7eWeBTK5ZWNgzF3ncCiQbfSaiuN9HWg2K3OctDbYn00fDjfitfK',
  productionSystemApiBaseUrl: `https://productionsystem-api.${domainName}/api/`,
  posApiBaseUrl: `https://pos-api.${domainName}/api`,
  companyApiBaseUrl: `https://company-api.${domainName}/api`,
  companyWebBaseUrl: `https://company.${domainName}`,
  listerWebBaseUrl: `https://lister.${domainName}`,
  posWebBaseUrl: `https://pos.${domainName}`,
  inventoryWebBaseUrl: `https://inventory.${domainName}`,
  imsApiUrl: `https://inventory-api.${domainName}/api/`,
  datadogAppId: '0b2bf306-323c-489a-90d3-9d00a5719468',
  datadogClientToken: 'pub14793bed69a3a0ff5f95a704ed92756d',
  chatbotEndpointIntegration: `https://productionsystem-ai.${domainName}/api/`,
  environmentName: 'dev',
};
